//Mahesh S: 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- Start
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzButton, BzCard, BzChip, BzInputText, BzScrollContainer } from '../../../../../components';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FILTER_DISPLAY_OPTIONS, ORDERS_TABKEY, ORDER_TYPES, SESSION_STORAGE_KEYS, TL_INDEX } from '../../../../../utils/global_variables';
import { StatusChip } from '../../../../Orders';
import { handleModal, handleModalData } from '../../../../../redux/actions/modals';
import { getWfhTouchlineLastTick } from '../../../../../redux/actions/wfh';
import { useUnload, useWFHMessages } from '../../../../../hooks';
import { getOrderDisplayDiscription, handleScripUnsubScriptionOnUnMount } from '../../../../../utils/global_functions';
import { sendTouchlineRequest } from '../../../../../apis/web_socket';
import { _getOrderDisplayStatus, _getQtyLotCaption } from '../../../../../controllers';
import ZeroStates from '../../../../ZeroStates';
import { ordersFilters } from '../../../../../controllers/netPosition';
import { updateFilters } from '../../../../../redux/actions/orders';
import moment from 'moment';

const SingleScrip = ({ handlePlaceOrder }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    let containerRef = useRef(null);

    const holdingsScrips = useSelector(state => state.holdings?.holdingsScrips);
    const modalData = useSelector(state => state.modals?.modalData);
    const activeOrders = useSelector(state => state.orders.orderTypes[0]);
    const objFilterData = useSelector(state => state?.orders?.objFilterData);
    const [arrOrders, setArrOrders] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [isSearchShoing, setIsSearchShowing] = useState(true);
    const [cancelAllShow, setCancelAllShow] = useState(false);
    const arrOrderCartdata = useSelector(state => state?.orderCart?.arrOrderCart);//BT-106965 : OrderCart : ManasaB:26-09-2024 : Smoke testing issue : Adding order cart name in side tray order book and dashboard
    useEffect(() => {
        setArrOrders(activeOrders);
    }, [activeOrders]);



    //Vaibhav Singh:23-02-24 Upadted changes in Data for handletoday postion: Start
    const handleTodayPositions = useCallback((arrTouchLineData) => {
        let todaysData = activeOrders;
        if (activeOrders?.data?.length > 0) {
            activeOrders?.data?.forEach((each, i) => {
                if (each?.MktSegId + '_' + each?.scripToken + '_' + each?.id === arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN] + '_' + each?.id) {
                    const objScripToBeUpdated = each;
                    objScripToBeUpdated.ltp = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
                    if (Object.keys(objScripToBeUpdated)?.length > 0) {
                        todaysData?.data?.splice(i, 1, objScripToBeUpdated);
                        setArrOrders({ ...todaysData });
                    }
                }
            });
        }
    }, [activeOrders]);

    useWFHMessages('touchline', (e) => {
        handleTodayPositions(e.detail);
    });


    useEffect(() => {
        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        if (Object.keys(objLastTickData).length > 0) {
            if (activeOrders?.data?.length > 0) {
                activeOrders?.data?.forEach((each) => {
                    const arrLastTickData = objLastTickData[each?.MktSegId + '_' + each?.scripToken];
                    if (arrLastTickData?.length > 0) {
                        handleTodayPositions(arrLastTickData);
                    }
                });
            }
        }
    }, [activeOrders, dispatch]);

    const onSearchChange = (value) => {
        setSearchText(value);
    };

    const onSearchClose = () => {
        setSearchText();
        setIsSearchShowing(true);
    };

    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -start
    const filteredData = useMemo(() => {
        if (modalData?.filter !== undefined) {
            if (Object?.keys(modalData?.filter)?.length > 0) {
                let filteredArray = ordersFilters(modalData?.filter, arrOrders?.data);
                if (searchText?.length > 0) {
                    filteredArray = filteredArray?.filter((each) => {
                        //Azeem K : 11-06-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX regression bug fixing - Start
                        const keywords = searchText?.toString()?.toLowerCase()?.split(' ');
                        let strRowData = each?.symbol + each?.exchange + moment(each?.expiryDate).format("DDMMMYYYY") + each?.strikePrice + each?.instrument + each?.optionType + each?.series;
                        return keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
                        //Azeem K : 11-06-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX regression bug fixing - End
                    });
                }
                return filteredArray;
            } else { }
        } else { }
        if (arrOrders?.data?.length > 0) {
            if (searchText?.length > 0) {
                const filteredPositions = arrOrders?.data?.filter((each) => {
                    //Azeem K : 11-06-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX regression bug fixing - Start
                    const keywords = searchText?.toString()?.toLowerCase()?.split(' ');
                    let strRowData = each?.symbol + each?.exchange + moment(each?.expiryDate).format("DDMMMYYYY") + each?.strikePrice + each?.instrument + each?.optionType + each?.series;
                    return keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
                    //Azeem K : 11-06-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX regression bug fixing - End
                }); return filteredPositions;
            } else {
                return arrOrders?.data;
            }
        } else { }

        return arrOrders?.data;
    }, [searchText, modalData, arrOrders]);
    //Vaibhav Singh: 20-02-24:Added cancel all issue: Start 
    useEffect(() => {
        if (activeOrders?.metadata?.open_records) {
            setCancelAllShow(false);
        } else {
            setCancelAllShow(true);
        }
    }, [activeOrders?.metadata]);
    //Vaibhav Singh:23-02-24 Upadted changes in Data for handletoday postion: End
    //Vaibhav Singh: 20-02-24:Added cancel all issue: End
    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -end

    const allExchangeList = [...new Set(activeOrders?.data?.map(element => element?.exchange?.split('_')[0]))];
    const allProductType = [...new Set(activeOrders?.data?.map(element => element?.exchangeWiseProductType))];
    const allCartOrders = [...new Set(activeOrders?.data?.map(eachElement => eachElement?.orderCartName))];//BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : SAT Issue : Added filter based on cart name in orders
    //Vaibhav Singh: 05-02-24: BT-107431: Updated Filter Lofic : Start

    // Vinit R : 12-03-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings -- Start
    const orderStatusFilters = [...new Set(activeOrders?.data?.map(orders => _getOrderDisplayStatus(orders?.status)))];
    // Vinit R : 12-03-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings -- End

    const handleFilters = () => {
        if (activeOrders?.data?.length) {
            dispatch(handleModal([{ "FILTER_ORDER_POSITION_MODAL": true }]));
            dispatch(handleModalData({ type: 'Orders', allExchangeList: allExchangeList, allProductType: allProductType, orderStatusFilters, allCartOrders })); //BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : Adding cart name filter in orders
        }
    };
    // Vinit R : 21-02-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings -- End
    function getQuatityAndValue(obj) {
        const caption = _getQtyLotCaption(obj?.MktSegId, obj?.market_lot, false);
        return caption;
    }

    const handleOrderHistory = (id) => {
        const path = `/orders?section=${ORDER_TYPES.SINGLE_SCRIP}&ordertype=${ORDERS_TABKEY.ALL_ORDERS}`;
        navigate(path, { state: id });
        sessionStorage.setItem(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
    };
    const handleClickChips = (ele) => {
        delete objFilterData[ele];
        dispatch(handleModalData({ filter: objFilterData }));
        dispatch(updateFilters(objFilterData));
    };
    const startObserving = () => {
        return new Promise((resolve) => {
            const observer = new IntersectionObserver((entries) => {
                const visible = entries?.filter((entry) => entry?.isIntersecting)?.map((entry) => entry?.target?.id);
                resolve(visible);
            }, {
                root: containerRef?.current,
                threshold: 0.1
            });
            const container = containerRef?.current;
            if (container) {
                Array?.from(container?.children[0].children[0]?.children[0]?.children[0]?.children)?.forEach((child) => observer?.observe(child));
            }
        });

    };

    const [objScripsRequest, setObjScripsRequest] = useState({});
    const handleSideBArSingleScripOrders = useCallback(async () => {
        let dahsboardWatchlistData = await startObserving();
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]

            const arrVisibleRows = dahsboardWatchlistData.map(item => {
                let id = item;
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({ exchangeId: Number(item?.split("_")[0]), token: Number(item?.split("_")[1]), isSubscribe: true });

                }
                return { exchangeId: Number(item?.split("_")[0]), token: Number(item?.split("_")[1]), isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);
            // lasttick of dashboard quick watchlist is being done inside of watchlist cards so not doing them here
            return { ...objpreviosScripsCopy };
        });
    }, []);
    const handleScrollOfOrders = useCallback((event) => {
        handleSideBArSingleScripOrders();
    }, [handleSideBArSingleScripOrders]);


    useEffect(() => {
        if (filteredData?.length > 0) {
            handleSideBArSingleScripOrders();
        }
    }, [filteredData]);

    const handleSideSingleOrdersUnSubscription = useCallback(() => {
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'Side bar single scrip');
    }, [objScripsRequest]);


    useUnload(() => {
        handleSideSingleOrdersUnSubscription();
    });

    return (
        <>
            <Container fluid className='p-0 px-3'>
                <Row className='g-0 py-1 mb-2 align-items-center h_40'>
                    <Col md={3} className='d-flex justify-content-start align-items-center'>
                        <Link to={!cancelAllShow ? `/orders?section=singleorderscancel` : null}>
                            <BzButton className='btn btn-sm btn-outline text-truncate' disabled={cancelAllShow}>Cancel All</BzButton>
                        </Link>
                    </Col>
                    <Col md={9} className='d-flex justify-content-end align-items-center'>
                        {isSearchShoing === true ?
                            <div onClick={() => activeOrders?.data?.length > 0 ? setIsSearchShowing(false) : null} className={`icon-16 icon-search ${activeOrders?.data?.length > 0 ? 'icon-dark' : 'icon-grey'}`}></div>
                            : <>
                                <div className='position-relative w-70'>
                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                    <BzInputText autoFocus onChange={(e) => onSearchChange(e.target.value)} size='sm' type='search' placeholder="Search Scrips" className='p-l-30 font-regular scripname-searchtext'></BzInputText>
                                </div>
                                <div className='icon-16 icon-dark icon-close ms-2' onClick={() => onSearchClose()} />
                            </>
                        }
                        <div className={`icon-16 icon-searchfilter ${activeOrders?.data?.length ? 'icon-dark' : 'icon-grey'} ms-3`} onClick={handleFilters}></div>
                        <Link to='/orders?section=single_scrip'>
                            <div className='icon-14 icon-redirect icon-dark ms-3'></div>
                        </Link>
                    </Col>
                </Row>
                {Object.keys(objFilterData)?.length ?
                    <Row className='g-0 mb-3'>
                        <Col className='d-flex'>
                            <div className='font-medium font-size3 color-text m-1'>Filters:</div>
                            <div className='horizontal-scroll-wrap filters-chips-wrap flex-nowrap'>
                                {Object.keys(objFilterData)?.map((ele, i) => {
                                    return <div key={i} className='chips chips default-chip text-capitalize m-1'>
                                        {ele === 'order_cart' ? `${ele} : ${objFilterData[ele]}` : objFilterData[ele] === "low_high" ? `${ele} : Low-High` : objFilterData[ele] === "high_low" ? `${ele} : High-Low` : parseFloat(objFilterData[ele]) ? `${ele.slice(-3)} : ${objFilterData[ele]}` : `${FILTER_DISPLAY_OPTIONS?.[ele] ? FILTER_DISPLAY_OPTIONS?.[ele] : ele} : ${objFilterData[ele]}`} <div style={{ width: "6px", height: '6px', marginLeft: "6px" }} onClick={handleClickChips?.bind(this, ele)} className='icon-16 icon-dark icon-close'></div>
                                    </div>;
                                })
                                }
                            </div>
                        </Col>
                    </Row>
                    : null
                }
            </Container>

            {activeOrders?.data?.length > 0 ?
                <Container fluid className='p-0'>
                    <BzScrollContainer className={'p-0 sticky-orderpositions-height px-3'} onScrollEnd={(e) => handleScrollOfOrders(e)} contaierref={containerRef}>
                        <Row className='g-0'>
                            <Col>
                                <div className='p-0'>
                                    <div className='transparent-card-wrap mb-2' >
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - Start*/}
                                        {filteredData?.length > 0 ? filteredData?.map((each, i) => (
                                            <BzCard key={i} id={each?.MktSegId + '_' + each?.scripToken} className='transparent-card cursor-pointer bdr-btm' onClick={() => handleOrderHistory(each?.id)}>
                                                <Row className='g-0'>
                                                    <Col md={6} className='d-flex justify-content-start align-items-center'>
                                                        <div className='font-medium font-size3 color-text text-uppercase me-2'>{each?.symbol}</div>
                                                        <div className='chips-wrap'>
                                                            <BzChip className='exchange-chip'>{each?.exchange?.split('_')[0]} </BzChip>
                                                        </div>

                                                    </Col>
                                                    <Col md={6} className='d-flex justify-content-end align-items-center'>
                                                        <div className='chips-wrap'>
                                                            <StatusChip data={each} strClass='d-flex justify-content-end align-items-center' />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0 mb-1'>
                                                    <Col className='d-flex'>
                                                        <div className='font-regular font-size2 color-subtext text-uppercase'>{getOrderDisplayDiscription(each)} </div>
                                                        {/* <div className='font-regular font-size2 color-subtext ps-1'>{each?.orderType === 'OPTION' ? (each?.expiryDate)(each?.instrument) : ''}</div> */}
                                                        {/* {dontMissData?.some(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === each?.MktSegId + '_' + each?.scripToken)
                                                            ?
                                                            <div className='icon-16 icon-dontmiss icon-yellow float-start ps-1'></div> : null} */}
                                                        {(holdingsScrips?.some(element => element?.nMarketSegmentId + '_' + element?.nToken === each?.MktSegId + '_' + each?.scripToken) ?
                                                            <div className='icon-16 icon-portfolio icon-dark ms-2'></div> : null)}
                                                    </Col>
                                                </Row>
                                                <Row className='g-0 mb-1'>
                                                    <Col md={6} className='d-flex justify-content-start align-self-center'>
                                                        <div className='font-regular font-size2 color-text'>
                                                            <span className={`font-medium color-text ${each?.type === 'BUY' ? 'color-positive' : 'color-negative'} `}>{each?.type}:</span> {each?.totalQuantity} {getQuatityAndValue(each)} @ ₹{each?.price}
                                                        </div>
                                                    </Col>
                                                    <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                        <div className='font-regular font-size2 color-subtext'>
                                                            <span className='font-medium color-text'>{each?.qty}</span> {getQuatityAndValue(each)}
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0 mb-1'>
                                                    <Col md={6} className='chips-wrap'>
                                                        <div className='d-flex justify-content-start align-self-center'>
                                                            <BzChip className='chips primary-chip text-capitalize'>{each?.exchangeWiseProductType}</BzChip>
                                                        </div>
                                                        {/* BT-106965 : OrderCart : ManasaB:26-09-2024 : Smoke testing issue : Adding order cart name in side tray order book and dashboard - Start */}
                                                        <div className='chips-wrap px-2'>
                                                            {
                                                                each?.orderCartName && (
                                                                    <>
                                                                        <BzChip className='chips primary-chip text-capitalize'>
                                                                            <div className='icon-12 icon-cart icon-primary float-start me-1 m-t-1'></div>
                                                                            <span className='float-start'>{each?.orderCartName}</span>
                                                                        </BzChip>
                                                                    </>
                                                                )
                                                            }
                                                        </div>
                                                        {/* BT-106965 : OrderCart : ManasaB:26-09-2024 : Smoke testing issue : Adding order cart name in side tray order book and dashboard - End */}
                                                    </Col>
                                                    <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                        <div className='font-regular font-size2 color-text text-end'>
                                                            <span className='color-subtext'>LTP: </span>{each?.ltp}
                                                        </div>

                                                    </Col>
                                                </Row>
                                                <Row className='g-0'>
                                                    <Col className='d-flex justify-content-start align-items-center'>
                                                        <div className='font-regular font-size1 color-subtext me-2'>{moment(each?.time + each?.date).format("hh:mm:ss A, DD MMM 'YY")}</div>
                                                    </Col>

                                                </Row>
                                            </BzCard>
                                        )) :
                                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                                <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                                <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                                <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                                            </div>
                                        }
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - End*/}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </BzScrollContainer>
                </Container>
                :
                <div className='zero-state-alerts zero-state-alerts-xl'>
                    <ZeroStates handleOnClick={handlePlaceOrder} subText="No orders available" icon='icon-100 icon-nodata mb-2 mrgauto' btnText='Place an order today' btnClass='btn btn-md btn-outline mt-2' />
                </div>
            }
        </>
    );
};

export default SingleScrip;
//Mahesh S: 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings - End
